<template>
  <div id="app">
    <section id="top">
      <!--      <Fog />-->
      <h1 class="top__header_name">Michal Ševčík</h1>
      <h2 class="top__header_role">Fullstack JavaScript developer</h2>
    </section>

    <div id="wrapper">
      <div id="top__introduction__wrapper">
        <Introduction id="top__introduction" />
      </div>

      <main id="content">
        <div id="content__technologies">
          <BorderedBox green>
            <Header first h2>Skills</Header>
            <Skills />
          </BorderedBox>

          <BorderedBox green>
            <Header first h2>Articles</Header>
            <ul class="content__articles-list">
              <li>
                <Link
                  href="https://javascript-sorcery.netlify.com/regular-function-vs-arrow-function/"
                  target="_blank"
                >
                  6 differences between regular functions and arrow functions
                  <!-- eslint-disable-next-line -->
                </Link>
              </li>
              <li>
                <Link
                  href="https://javascript-sorcery.netlify.com/delayed-class-instantiation/"
                  target="_blank"
                >
                  Delayed class instantiation
                  <!-- eslint-disable-next-line -->
                </Link>
              </li>
              <li>
                <Link
                  href="https://javascript-sorcery.netlify.com/git-tips/"
                  target="_blank"
                >
                  Useful tips for using GIT from command line
                  <!-- eslint-disable-next-line -->
                </Link>
              </li>
              <li>
                <Link
                  href="https://medium.com/@MelkorNemesis/6-different-array-flattening-methods-in-javascript-performance-testing-included-cbadd928cf62"
                  target="_blank"
                >
                  Flattening arrays in JavaScript
                  <!-- eslint-disable-next-line -->
                </Link>
              </li>
              <li>
                <Link
                  href="https://dev.to/melkornemesis/how-to-curry-this--uncurry-this-4l9f"
                  target="_blank"
                >
                  How to uncurry this
                  <!-- eslint-disable-next-line -->
                </Link>
              </li>
              <li>
                <Link
                  href="https://medium.com/@MelkorNemesis/handling-javascript-mouseup-event-outside-element-b0a34090bb56"
                  target="_blank"
                >
                  Handling JavaScript mouseup event outside element
                  <!-- eslint-disable-next-line -->
                  </Link>
              </li>
              <li>
                <Link
                  href="https://medium.com/@MelkorNemesis/javascript-lazy-evaluation-iterables-iterators-e0770a5de96f"
                  target="_blank"
                >
                  JavaScript lazy evaluation: Iterables & Iterators
                  <!-- eslint-disable-next-line -->
                </Link>
              </li>
              <li>
                <Link
                  href="https://medium.com/javascript-in-plain-english/javascript-lazy-evaluation-generators-examples-included-f9eaa517f969"
                  target="_blank"
                >
                  JavaScript Lazy Evaluation: Generators (Examples Included)
                  <!-- eslint-disable-next-line -->
                </Link>
              </li>
              <li>
                <Link
                  href="https://medium.com/javascript-in-plain-english/javascript-the-power-of-recursion-f56effadf63b"
                  target="_blank"
                >
                  JavaScript: The Power of Recursion
                  <!-- eslint-disable-next-line -->
                </Link>
              </li>
            </ul>

            <Header h2>Open source</Header>
            <ul class="content__articles-list">
              <li>
                <Link href="https://www.npmjs.com/package/react-downcount">
                  react-downcount
                  <!-- eslint-disable-next-line -->
                </Link>
              </li>
            </ul>
          </BorderedBox>
        </div>

        <div id="content__positions">
          <Header first gradient h2>Recent positions</Header>

          <JobPosition
            current
            title="Dixons Carphone CoE, s.r.o."
            :hash_tags="['react', 'redux', 'less', 'jest']"
            duration="September '19 - Present"
          >
            I have returned to Dixons Carphone to help develop product increment
            initiatives (care services, contactless collection, ...) within the
            checkout process using React ecosystem. Mentoring other team
            members. Refactoring current codebase and reducing technical debt.
            Putting in place techniques to speed up development process. Team
            size: ~15 people.
          </JobPosition>

          <JobPosition
            title="MONETA Money Bank"
            :tags="['remote']"
            :hash_tags="['react', 'redux', 'redux-saga', 'jest', 'cypress']"
            duration="June '18 - September '19"
          >
            Working on multiple onboarding applications - current accounts,
            savings accounts - using React ecosystem. Both mobile and desktop
            journeys. Preparing and installing solutions by determining and
            designing system specs and programming. One-man show front-end
            development. Team size: ~12 people.
          </JobPosition>

          <JobPosition
            title="Looop Ltd."
            :tags="['remote']"
            :hash_tags="[
              'nodejs',
              'express',
              'koa',
              'postgresql',
              'rest',
              'react',
              'redux',
              'mobx',
              'less',
              'aws'
            ]"
            duration="September '17 -  May '18"
          >
            Working on a learning management system, single page application
            using React ecosystem. Team size: 3 people. Documenting and
            demonstrating solutions by developing documentation, flowcharts,
            diagrams. Full stack development using Node.js.
          </JobPosition>

          <JobPosition
            title="Dixons Carphone CoE, s.r.o."
            :hash_tags="['react', 'redux', 'less', 'jest']"
            duration="May '15 -  September '17"
          >
            Working on a brand new checkout process for one of the UK's largest
            e-commerce retailers. Single page application using React ecosystem.
            Tech lead role. Investigating problem areas. Determining and
            designing system specifications. Cooperating with other teams and
            bringing UX concepts to life. Team size: ~10 people.
          </JobPosition>
        </div>

        <div id="content__socials">
          <a
            class="twitter-timeline"
            data-height="800"
            href="https://twitter.com/melkornms?ref_src=twsrc%5Etfw"
            >Tweets by @melkornms</a
          >
        </div>
      </main>
    </div>

    <Footer />
  </div>
</template>

<script>
import {
  BorderedBox,
  Footer,
  Header,
  Introduction,
  JobPosition,
  Skills
} from "./components";

import { supportsWebp } from "./utils/browser";
import Link from "./components/Link";

export default {
  name: "app",
  components: {
    Link,
    BorderedBox,
    Footer,
    // Fog,
    Header,
    Introduction,
    JobPosition,
    Skills
  },
  async beforeMount() {
    if (await supportsWebp()) {
      document.body.classList.add("webp");
    } else {
      document.body.classList.add("no-webp");
    }
  },
  created() {
    const script = document.createElement("script");
    script.src = "https://platform.twitter.com/widgets.js";
    document.body.appendChild(script);
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i|Righteous&display=swap&subset=latin-ext");
@import "./styles/_variables.scss";

html {
  font-size: 16px;
}

* {
  box-sizing: border-box;
}

.italic {
  font-style: italic;
}

body {
  padding: 0;
  margin: 0;

  font-family: $font;

  &.webp {
    background: url(./assets/top_bg.webp) top center no-repeat;
  }

  &.no-webp {
    background: url(./assets/top_bg.png) top center no-repeat;
  }
}

#top {
  position: relative;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 597px;
  padding: $spacing4;
}

.top__header_name,
.top__header_role {
  position: relative;
  z-index: 1;

  color: #fff;
  font-family: $font-alt;
  text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.2);
  font-weight: 400;
  text-align: center;
  line-height: 1;
}

.top__header_name {
  margin-top: 0;
  margin-bottom: 28px;
  // 51px + 3vw
  font-size: calc(3.1875rem + 3vw);
}

.top__header_role {
  margin: 0;
  // 13px + 0.6vw
  font-size: calc(0.8125rem + 0.6vw);
}

#top__introduction__wrapper {
  display: flex;
  justify-content: center;
  padding: 0 $spacing4;
  margin-top: -80px;
}

#top__introduction {
  max-width: 1140px;
  width: 100%;
}

#wrapper {
  position: relative;
  z-index: 1;
  padding-bottom: 40px;

  @media (min-width: 580px) {
    padding-bottom: 100px;
  }
}

#content {
  display: grid;
  grid-template-areas:
    "tech"
    "positions";
  grid-template-columns: 1fr;
  grid-gap: 35px;
  padding: 0 $spacing4;
  margin-top: 54px;
  margin-left: auto;
  margin-right: auto;
  max-width: 960px;
  width: 100%;

  @media (min-width: 580px) {
    grid-template-areas: "tech positions";
    grid-template-columns: 5fr 6fr;
  }

  @media (min-width: 768px) {
    grid-template-areas: "tech positions socials";
    grid-template-columns: 4fr 4fr 3fr;
  }

  & > #content__technologies {
    grid-area: tech;
  }

  & > #content__positions {
    grid-area: positions;
  }

  & > #content__socials {
    grid-area: socials;
    display: none;

    @media (min-width: 768px) {
      display: block;
    }
  }

  .content__articles-list {
    padding-left: 0;
    margin-bottom: 0;

    li {
      list-style-type: none;

      & + li {
        margin-top: 0.5em;
      }
    }
  }
}
</style>
